import { render, staticRenderFns } from "./edgeSpacer.vue?vue&type=template&id=d959d22e&scoped=true&"
import script from "./edgeSpacer.vue?vue&type=script&lang=js&"
export * from "./edgeSpacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d959d22e",
  null
  
)

export default component.exports